namespace advisorop.services {
    `use strict`;

    export class HouseholdApi {

        readonly apiUrl = `/api/household`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        getAccountGroupsSummary(
            id: number,
            groupType: domains.AccountGroupType,
            showClosedInactive: boolean = false,
            loadHistData: boolean = false): ng.IHttpPromise<any> {
            let url = `${this.apiUrl}/${id}/accountgroups/${groupType}/summary?showClosedInactive=${showClosedInactive}`;
            if (loadHistData) {
                url = `${url}&includeHist=${loadHistData}`;
            }

            return this.$http.get(`${url}`);
        }

        getChartsUrl(
            id: number,
            groupType: number,
            chartGroup: string,
            groupId: number,
            accountId: number,
            sleeveId: number,
            showClosedInactive?: boolean,
            hideSleeves?: boolean,
            xlsx: boolean = false,
            loadHistData: boolean = false,
            histChartDateType: domains.HistChartDateType = domains.HistChartDateType.LAST_SIX_MONTHS
        ): string {
            let url = `${this.apiUrl}/${id}/charts`;
            if (xlsx) {
                url = `${url}/xlsx?groupType=${groupType}&chartGroup=${chartGroup}`
            } else {
                url = `${url}?groupType=${groupType}&chartGroup=${chartGroup}`
            };

            if (groupId) {
                url = `${url}&groupId=${groupId}`;
            }
            if (accountId) {
                url = `${url}&accountId=${accountId}`;
            }
            if (sleeveId) {
                url = `${url}&sleeveId=${sleeveId}`;
            }
            if (showClosedInactive) {
                url = `${url}&showClosedInactive=${showClosedInactive}`;
            }
            if (hideSleeves) {
                url = `${url}&hideSleeves=${hideSleeves}`;
            }
            if (loadHistData) {
                url = `${url}&includeHist=${loadHistData}&histChartDateType=${histChartDateType}`;
            }

            return url;
        }

        getCharts(
            id: number,
            groupType: number,
            chartGroup: string,
            groupId: number,
            accountId: number,
            sleeveId: number,
            showClosedInactive?: boolean,
            hideSleeves?: boolean,
            loadHistData: boolean = false,
            histChartDateType: domains.HistChartDateType = domains.HistChartDateType.LAST_SIX_MONTHS): ng.IHttpPromise<domains.IChartsDataSource> {

            const url = this.getChartsUrl(id, groupType, chartGroup, groupId, accountId, sleeveId, showClosedInactive, hideSleeves, false, loadHistData, histChartDateType);
            return this.$http.get<domains.IChartsDataSource>(url);
        }

        getChartsXlsx(
            id: number,
            groupType: number,
            chartGroup: string,
            groupId: number,
            accountId: number,
            sleeveId: number,
            showClosedInactive?: boolean,
            hideSleeves?: boolean): ng.IHttpPromise<domains.IChartsDataSource> {
            const url = this.getChartsUrl(id, groupType, chartGroup, groupId, accountId, sleeveId, showClosedInactive, hideSleeves, true, false);
            return this.$http.get<domains.IChartsDataSource>(url);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("householdApi", HouseholdApi);
}